module.exports = __webpack_public_path__ + "static/media/pencil-edit.d91f74e0.svg";